import { render, staticRenderFns } from "./GraphVariety.vue?vue&type=template&id=9045e648&"
import script from "./GraphVariety.vue?vue&type=script&lang=js&"
export * from "./GraphVariety.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports